import React from 'react';
import { Formik } from 'formik';
import {
	useListAdditionalFoldersQuery,
	useSaveAdditionalFoldersMutation,
} from '@/features/additionalFolders/additionalFoldersApi';
import { showToast } from '@/features/toast/toastSlice';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { useDispatch, useSelector } from 'react-redux';
import {
	ADDITIONAL_FOLDER_TABS,
	additionalFoldersValidationSchema,
	getAdditionalFolderInitialValues,
} from '@/utils/additionalFolderAutomation';
import { AdditionalFolderFormContent } from './AdditionalFolderFormContent';

export const AdditionalFolderAutomationDrawerForm = () => {
	const dispatch = useDispatch();
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { getFeatureFlags } = useFeatureFlagContext();
	const canEdit = Boolean(getFeatureFlags('editAutomations')?.active);
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const brokerGroupIds = userDetails?.brokerGroupArray;
	const [saveAdditionalFolders] = useSaveAdditionalFoldersMutation();
	const { data: folders, isLoading } = useListAdditionalFoldersQuery(
		{ brokerGroupIds },
		{ skip: !brokerGroupIds?.length },
	);

	return (
		<Formik
			enableReinitialize
			initialValues={getAdditionalFolderInitialValues(folders)}
			validationSchema={additionalFoldersValidationSchema}
			onSubmit={async (values, { setSubmitting }) => {
				const foldersToSave = Object.fromEntries(
					ADDITIONAL_FOLDER_TABS.map(({ key }) => [
						key,
						values[key].map((name) => name.trim()).filter(Boolean),
					]),
				);

				try {
					await saveAdditionalFolders({ foldersToSave }).unwrap();
					dispatch(
						showToast({
							message: 'Additional folders saved',
							success: true,
							duration: 5000,
							autohide: true,
						}),
					);
				} catch (error) {
					console.error('Failed to save additional folders', error);
					dispatch(
						showToast({
							message: 'Could not save additional folders',
							error: true,
							duration: 5000,
							autohide: true,
						}),
					);
				} finally {
					setSubmitting(false);
				}
			}}
		>
			<AdditionalFolderFormContent canEdit={canEdit} isLoading={isLoading} />
		</Formik>
	);
};

export default AdditionalFolderAutomationDrawerForm;
